import { DataObject } from '@shared/models/data-object.model';
import { MiqMoment } from '@shared/utils/helpers/sanitizers';

export const reportNameExtractor = ({ name }: DataObject) => {
  const path = name.split('/');
  return decodeURIComponent(path[path.length - 1]);
};

export const serializeFolderPath = path => path.split('/').map(encodeURIComponent).join('/');

export const deserializeFolderPath = path => path.split('/').map(decodeURIComponent).join('/');

export const subTitleExtractor = ({ name }) => deserializeFolderPath(name.substring(0, name.lastIndexOf('/')));

export const dateFormatter = (field, format, row) => (row[field] ? MiqMoment.format(row[field], format) : '');
